import { usePresenceHeartbeat } from '@/hooks/use-presence-heartbeat';

/**
 * Spec 525: null-rendering carrier for the presence heartbeat. Mount once inside
 * the auth provider, above the routes, so the heartbeat interval survives
 * navigation and only runs while signed in.
 */
export function PresenceHeartbeat() {
  usePresenceHeartbeat();
  return null;
}
